import React, { useEffect, useState } from "react";

import {
  Container,
  Form,
  WrapperForm,
  LeftSide,
  InputRow,
  ScheduleCard,
  Title,
  DateTag,
  Header,
  Description,
  InfoText,
  DateRow,
  DescriptionText,
  FormContent,
  Cards,
} from "./styles";
import { Button } from "../../../components/videoConference/Button";
import { Input } from "../../../components/videoConference/Input";
import { Modal } from "../../../components/videoConference/Modal";
import { ArrowRight } from "../../../components/videoConference/icons/ArrowRight";

// import { SubmitHandler, useForm } from "react-hook-form";
// import { zodResolver } from "@hookform/resolvers/zod"
import { getEventStyles, getWebinars } from "../api";
import { StylesProps, WebinarsProps } from "../types";
import { getContrastColor } from "../../../utils/isDarkColor";
import { useParams, useHistory } from "react-router-dom";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
interface IUserForm {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  company: string;
}

interface IStoragedUser {
  name: string;
  company: string;
  email: string;
  talk: string;
}

interface IFormData {
  email: string;
  attendee_name: string;
  Empresa: string;
  phone: string;
  access_code: string;
  custom_var: string;
  invite_email: string;
  playlist: string;
  [key: string]: string;
}

const monthsPortugese = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const monthsEnglish = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];



function formatPhoneNumber(phone: string): string {
  if (!phone) return phone
  const numeros = phone.replace(/\D/g, '');
  if (numeros.length === 11) {
    return numeros.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '($1) $2$3-$4');
  } else if (numeros.length === 10) {
    return numeros.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  } else {
    return phone;
  }
}

interface RouteParams {
  kind: string;
}

export default function FormRegister({
  playback
}: {
  playback: string
}) {
  const history = useHistory()
  const [userData, setUserData] = useState<IUserForm>({
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phone: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState({ title: "", description: "" });
  const [talk, setTalk] = useState("");
  const [styles, setStyles] = useState<StylesProps | null>(null)
  const [webinars, setWebinars] = useState<WebinarsProps | null>(null)
  const [error, setError] = useState(false)
  const [isChecked, setIsChecked] = useState(false);

  const { i18n } = useTranslation();

  const isPt = i18n.language === "pt" || i18n.language === "pt-BR";


  const query = useParams<RouteParams>();

  useEffect(() => {
    getStyles()
    getGroup()
  }, [query.kind])

  useEffect(() => {
    if (webinars) {
      if (localStorage.getItem(`@NDI-WEBINAR-${webinars?.name}`)) {
        history.push(`/${query.kind}/assista`)
      }
      const params = new URLSearchParams(playback);

      const playbackValue = params.get('playback');

      if (!playbackValue) {
        setTalk(webinars?.talks[0]?.playback_stream_name)
      } else {
        setTalk(playbackValue)
      }
    }

  }, [webinars, playback])

  async function getStyles() {
    if (query.kind) {
      const response = await getEventStyles({
        kind: query.kind
      })
      setStyles(response.data)
    }
  }

  async function getGroup() {
    if (query.kind) {
      const response = await getWebinars({
        kind: query.kind
      })

      if (response.data.length === 0) return
      setWebinars(response.data.groups[0])
    }
  }

  // const { handleSubmit, register, setValue, formState: { errors } } = useForm<RegisterFormType>({
  //   resolver: zodResolver(RegisterSchema)
  // });

  const displayMessage = (
    title: string,
    description: string,
    onTimeout?: () => void
  ) => {
    setMessage({ title, description });
    setShowModal(true);

    // setTimeout(function () {
    //   setShowModal(false);
    //   setMessage({ title: "", description: "" });
    //   onTimeout && onTimeout();
    // }, 5000);
  };

  const onChange = (value: string, attr: keyof IUserForm) => {
    setUserData((prev) => ({ ...prev, [attr]: value }));
    // setValue(attr, value);
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value)
    const inputValue = e.target.value
    onChange(inputValue, "phone");
  };

  // const onRegister: SubmitHandler<RegisterFormType> = async (resultData: RegisterFormType) => {
  const onRegister = async (event: any) => {
    event.preventDefault();
    if (!userData.firstName || !userData.lastName || !userData.email || !userData.phone || !userData.company) {
      setError(true)
      return
    }

    if (window.location.href.includes("ambev") && !isChecked) {
      setError(true)
      return
    }

    const btnRegister = document.getElementById(
      "btnRegister"
    ) as HTMLButtonElement;
    if (btnRegister) {
      btnRegister.disabled = true;
      btnRegister.value = "Enviando...";
    }

    const name = userData.firstName + " " + userData.lastName;

    const formData = new FormData();
    const data: IFormData = {
      email: userData.email,
      attendee_name: name,
      Empresa: userData.company,
      phone: userData.phone.toString(),
      access_code: "",
      custom_var: "",
      invite_email: "",
      playlist: "",
    };
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        formData.append(key, data[key]);
      }
    }
    try {
      // const response = await fetch(
      //   `https://www.eventials.com/nucleodeimagem/groups/${webinars && webinars?.slug}/subscribe/`,
      //   {
      //     method: "POST",
      //     body: formData,
      //   }
      // );
      const currentTalk = webinars?.talks.find(t => t.playback_stream_name === talk)
      const response = await fetch(
        `https://www.eventials.com/${currentTalk?.owner_username}/${currentTalk?.slug}/subscribe/`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        const userInfos: IStoragedUser = {
          email: userData.email,
          name: name,
          company: userData.company,
          talk
        };
        localStorage.setItem(`@NDI-WEBINAR-${webinars?.name}`, JSON.stringify(userInfos));
        history.push(`/${query.kind}/assista`)
        return;
      } else {
        displayMessage(
          t("modal.error.title"),
          t("modal.error.text")
        );
        return;
      }
    } catch (err) {
      console.log("ocorreu um erro", err);
      displayMessage(
        t("modal.error.title"),
        t("modal.error.text")
      );
      btnRegister.disabled = false;
      btnRegister.value = "Inscreva-se";

      return;
    }
  };

  function getDate(date: string) {
    if (!date) return ""
    const dateSplited = date.split("/")
    const day = dateSplited[0]
    const month = dateSplited[1]

    if (isPt) return `${day}/${month}`

    return `${month}/${day}`
  }

  function getDateDescription(date: string) {
    if (!date) return ""

    let parts = date.split(' às ');
    let data = parts[0].split('/');
    let day = data[0];
    let monthNumber = parseInt(data[1], 10);
    let year = data[2];
    let hourMinute = parts[1];

    let monthName = monthsPortugese[monthNumber - 1];
    let monthNameInEnglish = monthsEnglish[monthNumber - 1];

    if (isPt) {
      return `${day} de ${monthName} de ${year} às ${hourMinute}`
    } else {
      return `${monthNameInEnglish} ${day}, ${year}, at ${hourMinute}`
    }
  }

  function getHours(date: string) {
    let parts = date.split(' às ');
    let hourMinute = parts[1];

    if (isPt) {
      return `Às ${hourMinute} BRT`;
    }
    let hour = hourMinute.split(":")[0];
    if (parseInt(hour) > 12) {
      return `At ${hourMinute} PM EST`;
    }
    return `At ${hourMinute} AM EST`;
  }



  return (
    <>
      {showModal && (
        <Modal
          title={message.title}
          description={message.description}
          onClose={() => setShowModal(false)}
        />
      )}
      <Container backgroundColor={styles?.body?.form.pageBackground}>
        <WrapperForm>
          <LeftSide backgroundColor={styles?.body?.form.bannerBackground}>
            <Cards >
              {webinars?.talks.map((talk) => (
                <ScheduleCard >
                  <Title letterSpacing={"1px"} color={getContrastColor(styles?.body?.form.bannerBackground || "")}>
                    {talk.title}
                  </Title>
                  <DateRow>
                    <DateTag tagColor={styles?.body?.form.tagColor} style={{ color: getContrastColor(styles?.body?.form.tagColor || "") }}>{getDate(talk.date)}</DateTag>
                    <p style={{ color: getContrastColor(styles?.body?.form.bannerBackground || "") }}>
                      {getHours(talk.date)}
                    </p>
                  </DateRow>
                </ScheduleCard>
              ))
              }
            </Cards>
          </LeftSide>

          <Form onSubmit={onRegister}>
            <Header>
              <Title color="black">{webinars?.name}</Title>
              <Description>
                <DescriptionText textcolor="black">
                  {webinars?.description}
                </DescriptionText>
                <DescriptionText textcolor={styles?.body?.form.tagColor}>
                  {webinars?.talks && webinars?.talks.length > 0 ? getDateDescription(webinars?.talks[0].date) : ""}
                </DescriptionText>
              </Description>
            </Header>
            <InfoText>
              {t("form.description")}
            </InfoText>
            <FormContent>
              <InputRow>
                <Input
                  labelStyle={{
                    color: styles?.body?.form.tagColor
                  }}
                  // error={errors.firstName?.message}
                  // {...register("firstName")}
                  value={userData.firstName}
                  onChange={(e) => onChange(e.target.value, "firstName")}
                  placeholder={t("form.nameDescription")}
                  label={t("form.name")}
                />
                <Input
                  labelStyle={{
                    color: styles?.body?.form.tagColor
                  }}
                  // error={errors.lastName?.message}
                  // {...register("lastName")}
                  value={userData.lastName}
                  onChange={(e) => onChange(e.target.value, "lastName")}
                  placeholder={t("form.lastNameDescription")}
                  label={t("form.lastName")}
                />
              </InputRow>
              <InputRow>
                <Input
                  labelStyle={{
                    color: styles?.body?.form.tagColor
                  }}
                  // error={errors.email?.message}
                  // {...register("email")}
                  value={userData.email}
                  onChange={(e) => onChange(e.target.value, "email")}
                  placeholder={t("form.emailDescription")}
                  label={t("form.email")}
                />
                <Input
                  labelStyle={{
                    color: styles?.body?.form.tagColor
                  }}
                  // error={errors.phone?.message}
                  // {...register("phone")}
                  value={formatPhoneNumber(userData.phone)}
                  onChange={handlePhoneChange}
                  placeholder={t("form.phoneDescription")}
                  label={t("form.phone")}
                />
              </InputRow>
              <InputRow>
                <Input
                  labelStyle={{
                    color: styles?.body?.form.tagColor
                  }}
                  // error={errors.company?.message}
                  // {...register("company")}
                  value={userData.company}
                  onChange={(e) => onChange(e.target.value, "company")}
                  placeholder={t("form.companyDescription")}
                  label={t("form.company")}
                />
              </InputRow>
              {window.location.href.includes("ambev") && (
                <div>
                  <label >
                    <input
                      style={{ marginRight: "5px" }}
                      type="checkbox"
                      checked={isChecked}
                      onChange={event => setIsChecked(event.target.checked)}
                    />
                    {t("form.privacy")} <a style={{ cursor: "pointer" }} target="_blank" rel="noreferrer" href={isPt ? "https://ri.ambev.com.br/politica-de-privacidade/" : "https://ri.ambev.com.br/en/politica-de-privacidade/"}>{isPt ? "Política de Privacidade" : "Privacy Policy"}</a>.
                  </label>
                </div>
              )}
              <InputRow style={{ justifyContent: "space-between" }}>

                <select onChange={(e) => {
                  setTalk(e.target.value as string)
                }}
                  style={{ width: "100%", height: "40px", borderRadius: "4px", border: "1px solid #ccc", padding: "10px" }}
                  value={talk}
                >
                  {webinars?.talks.map((talk) => (
                    <option value={talk.playback_stream_name}>{talk.title}</option>
                  ))}
                </select>


                <Button
                  id="btnRegister"
                  RightIcon={<ArrowRight />}
                  background={styles?.body?.form.bannerBackground}
                  colorfont={getContrastColor(styles?.body?.form.bannerBackground || "")}
                  title={t("form.send")}
                  type="submit"
                />
              </InputRow>
            </FormContent>
            {error && (
              <p style={{ color: "red" }}>{t("form.error")}</p>
            )}
          </Form>
        </WrapperForm>
      </Container>
    </>
  );
}
